import { render, staticRenderFns } from "./CasePage.vue?vue&type=template&id=33f59e7d&scoped=true"
import script from "./CasePage.vue?vue&type=script&lang=js"
export * from "./CasePage.vue?vue&type=script&lang=js"
import style0 from "./CasePage.vue?vue&type=style&index=0&id=33f59e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f59e7d",
  null
  
)

export default component.exports